import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { HttpClient, HttpParams } from '@angular/common/http';
import { OcorrenciaTipo } from '../models/ocorrencia-tipo';

@Injectable({
  providedIn: 'root'
})
export class OcorrenciaTipoService {

  constructor(private http: HttpClient) { }

  consultarTodosOcorrenciaTipo() {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaTipo/Lista');
  }

  consultarPorIdSetor(idSetor: number) {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaTipo/ListaPorSetor',
      { params: new HttpParams().set('idSetor', idSetor.toString()) });
  }

  consultarComPaginacao(paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, descricao: string) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if(descricao) {
      parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaTipo/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorId(id: number) {
    return this.http.get<any>(globals.apiUrl + '/api/OcorrenciaTipo/Buscar',
      { params: new HttpParams().set('id', id.toString()) });
  }

  salvar(ocorrenciaTipo: OcorrenciaTipo) {
    return this.http.post(globals.apiUrl + '/api/OcorrenciaTipo/Salvar', ocorrenciaTipo);
  }

  excluir(idOcorrenciaTipo: number) {
    return this.http.delete(globals.apiUrl + '/api/OcorrenciaTipo/Excluir',
      { params: new HttpParams().set('id', idOcorrenciaTipo.toString()) });
  }
}
